var TECL_Master = {

    RunFreeTextSearch: function(element, searchUrl, searchDescendantsOfNode, additionalSearchItemsKey, resultItemsPartialViewName) {
        var searchText = "";
        if (typeof element === 'undefined') {
            searchText = $("#freeTextSearch").val();
        } else {
            searchText = $(element).val();
        }

        searchText = encodeURIComponent( searchText.trim().split( "," ).join( "" ) );

        searchDescendantsOfNode = searchDescendantsOfNode || 0;
        additionalSearchItemsKey = additionalSearchItemsKey || "";
        resultItemsPartialViewName = resultItemsPartialViewName || "";

        var nodeSearchParam = "";
        if (parseInt(searchDescendantsOfNode) > 0) {
            nodeSearchParam = "&searchDescendantsOfNode=" + searchDescendantsOfNode;
        }

        var searchKeyParam = "";
        if (additionalSearchItemsKey.length > 0) {
            searchKeyParam = "&additionalSearchItemsKey=" + additionalSearchItemsKey;
        }

        var viewParam = "";
        if (resultItemsPartialViewName.length > 0) {
            viewParam = "&resultItemsPartialViewName=" + resultItemsPartialViewName;
        }

        var url = "/umbraco/Surface/SearchResultsSurface/RunFreeTextSearch";
        if (searchText !== "") {
            searchUrl = searchUrl || "/searchresults";
            window.location.href = "/umbraco/Surface/SearchResultsSurface/RunFreeTextSearch?searchText=" +
                searchText +
                "&searchUrl=" +
                searchUrl +
                nodeSearchParam +
                searchKeyParam +
                viewParam;
        }
    },

    CheckFreeTextKeyDown: function(e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            //Enter Key has been pressed
            TECL_Master.RunFreeTextSearch();
        }
    },

    // Check if the text is an email address
    IsEmailAddress: function(emailAddressText) {
        var result = false;

        if ( emailAddressText ) {
            var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,10})?$/;
            result = emailReg.test( emailAddressText );
        }

        return result;
    },

    /*-------------------------------------------------------------------------------------
    The following JavaScript functions are for locking operations to prevent double clicking
    --------------------------------------------------------------------------------------*/
    LOCKVAR: null,

    // Attempt to add a lock to a key, if the key is already locked then return False, otherwise, add the lock and return True
    AddLock: function(key) {

        var lockCreated = false;

        if (key) {

            // Get the existing list of locks
            var locks = TECL_Master.LOCKVAR || [];

            if (!locks[key]) {
                // This key has not been locked so add it to the list of locks and return true
                locks[key] = true;
                TECL_Master.LOCKVAR = locks;
                lockCreated = true;
            }
        }

        return lockCreated;
    },

    // Remove the lock for key
    ClearLock: function(key) {

        if (key) {
            // Get the existing list of locks
            var locks = TECL_Master.LOCKVAR || [];

            // Delete the lock if required
            if (locks[key]) {
                delete locks[key];
                TECL_Master.LOCKVAR = locks;
            }
        }
    },

    GetParameterByName: function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    },

    // Stops a scrolling bug with the kendo dropdown control
    StopKendoDropDownScrollBug: function() {
        $("[data-role='dropdownlist']").each(function() {
            var widget = $(this).data("kendoDropDownList");
            if (widget) {
                TECL_Master.StopKendoScroll(widget.ul.parent());
            }
        });
    },

    // Stop scrolling from leaving a kendo control
    StopKendoScroll: function(element) {
        var activeElement;

        $(document).bind('mousewheel DOMMouseScroll', function(e) {
            var scrollTo = null;

            if (!$(activeElement).closest(".k-popup").length) {
                return;
            }

            if (e.type == 'mousewheel') {
                scrollTo = (e.originalEvent.wheelDelta * -1);
            }

            else if (e.type == 'DOMMouseScroll') {
                scrollTo = 40 * e.originalEvent.detail;
            }

            if (scrollTo) {
                e.preventDefault();
                element.scrollTop(scrollTo + element.scrollTop());
            }

        });

        $(document).on('mouseover', function(e) {
            activeElement = e.target;
        });
    }

};
